import { render, staticRenderFns } from "./wheelOverlayText.vue?vue&type=template&id=567bbdb5&scoped=true&"
import script from "./wheelOverlayText.vue?vue&type=script&lang=js&"
export * from "./wheelOverlayText.vue?vue&type=script&lang=js&"
import style0 from "./wheelOverlayText.vue?vue&type=style&index=0&id=567bbdb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567bbdb5",
  null
  
)

export default component.exports